import { FaGithub, FaYoutube, FaDiscord, FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export function Footer() {
  const currentYear = new Date().getFullYear();
  const historyYears = currentYear - 2000;

  const socialLinks = [
    {
      name: "GitHub",
      href: "https://github.com/ssugameworks",
      icon: <FaGithub className="w-5 h-5 md:w-6 md:h-6" />,
    },
    {
      name: "Email",
      href: "mailto:gameworks2026@gmail.com",
      icon: <MdEmail className="w-5 h-5 md:w-6 md:h-6" />,
    },
    {
      name: "YouTube",
      href: "https://www.youtube.com/@%EA%B2%8C%EC%9E%84%EC%9B%8D%EC%8A%A4",
      icon: <FaYoutube className="w-5 h-5 md:w-6 md:h-6" />,
    },
    {
      name: "Discord",
      href: "https://discord.com/invite/V5AGH3pdhF",
      icon: <FaDiscord className="w-5 h-5 md:w-6 md:h-6" />,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/gameworks_official?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
      icon: <FaInstagram className="w-5 h-5 md:w-6 md:h-6" />,
    },
  ];

  return (
    <footer className="w-full bg-footer px-6 md:px-16 lg:px-28 py-10">
      <div className="max-w-300 mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-8">
          <div className="flex flex-col gap-4 items-start">
            <span className="font-semibold text-snow text-[24px] md:text-[32px] tracking-[-1.28px] leading-[1.3]">
              GAMEWORKS
            </span>
            <p className="font-medium text-muted text-[16px] tracking-[-0.5px] leading-[1.5]">
              2000년부터 이어진 글로벌미디어학부<br className="md:hidden" /> 대표 학술 소모임입니다.
            </p>
          </div>
          <div className="flex gap-5 md:gap-6 items-center text-muted">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-snow transition-colors duration-200"
                aria-label={link.name}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 font-medium text-muted text-[13px] md:text-[14px] text-center tracking-[-0.3px] leading-[1.5]">
          <p>© {currentYear} GAMEWORKS, All rights reserved.</p>
          <p>{historyYears}년의 역사를 이어온 종합 학술 소모임, GAMEWORKS</p>
        </div>
      </div>
    </footer>
  );
}
